import React from "react"

export const field = "w-full h-10 !px-3 rounded-lg border border-slate-200 bg-white text-[13px] text-slate-800 placeholder-slate-400 " +
  "focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300 transition"
export const area  = field.replace("h-10", "!py-2")
export const label = "block text-[11.5px] font-medium text-slate-500 !mb-1"
export const card  = "bg-white border border-slate-200 rounded-xl !p-5"
export const link  = "inline-flex items-center gap-1.5 text-[12.5px] font-medium text-blue-600 hover:underline"

export const ActionIcon = ({ type }) => (
  <span className={`inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-lg ${type.tone}`}>
    <i className={`fas ${type.icon} text-[12px]`} />
  </span>
)

export const RemoveButton = ({ onClick, icon = "fa-trash" }) => (
  <button type="button" onClick={onClick} title={I18n.t("automations.form.remove")}
          className="grid h-7 w-7 shrink-0 place-items-center rounded-lg text-slate-400 hover:bg-slate-100 hover:text-rose-600">
    <i className={`fas ${icon} text-[11px]`} />
  </button>
)

export const Step = ({ tone, icon, title, hint, children }) => (
  <div className={card}>
    <div className="!mb-4 flex items-center gap-3">
      <span className={`grid h-7 w-7 shrink-0 place-items-center rounded-full text-[11px] ${tone}`}><i className={`fas ${icon}`} /></span>
      <div>
        <h2 className="text-[14px] font-semibold text-slate-900">{title}</h2>
        <p className="text-[12px] text-slate-500">{hint}</p>
      </div>
    </div>
    {children}
  </div>
)
